import { ACCEPTED_FILE_TYPES } from './acceptedFileTypes';

export { ACCEPTED_FILE_TYPES };
